<template>
  <div>
    <v-card-text class="d-flex align-center" style="gap:20px;">
      <v-card-title>
        <v-chip>{{ index + 1 }}</v-chip>
        <span
          style="color:black;font-size:15px;font-family:SourceSansProRegular, sans-serif;font-weight: bold;"
          >{{ label }}<span v-if="field.mandatory"> (*)</span>:</span
        >
      </v-card-title>
      <v-autocomplete
        v-model="data"
        :items="listItems"
        item-text="description"
        item-value="id"
        v-on:change="onInputChange"
        no-data-text="No hay datos disponibles"
        :readonly="!canEdit"
      ></v-autocomplete>
      <div v-if="field.requireScale">
        <v-select
          v-model="scaleValue"
          :items="listScaleValues"
          label="Escala"
          item-text="description"
          item-value="id"
          v-on:change="onInputChangeScaleValue"
          no-data-text="No hay datos disponibles"
          hint=""
          persistent-hint
          :disabled="!canEdit"
        ></v-select>
      </div>
      <!--select warning group-->
      <div>
        <template>
          <IncumplimientoIcon
            :incumplimiento="currentIncumplimiento"
          ></IncumplimientoIcon>
          <span class="requerimiento-status">{{ currentIncumplimiento }}</span>
          <span @click.stop="">
            <IncumplimientoEstado
              ref="incumplimiento"
              :incumplimiento="currentIncumplimiento"
              :field="field"
              :incumplimientos="incumplimientos"
              @changeCurrentIncumplimiento="changeCurrentIncumplimiento"
              :canEdit="canEdit"
            ></IncumplimientoEstado>
          </span>
        </template>
      </div>
      <div v-if="canChangeCheckbox">
        <template>
          <CorrectionIcon :correction="currentCorrection"></CorrectionIcon>
          <span class="requerimiento-status">{{ currentCorrection }}</span>
          <span @click.stop="">
            <CorrectionEstado
              ref="correction"
              :correction="currentCorrection"
              :field="field"
              :corrections="corrections"
              @changeCurrentCorrection="changeCurrentCorrection"
              :canEdit="canChangeCheckbox"
            ></CorrectionEstado>
          </span>
        </template>
      </div>
      <div v-if="canEdit && canViewCorrection">
        <template>
          <CorrectionIcon :correction="currentCorrection"></CorrectionIcon>
          <span class="requerimiento-status">{{ currentCorrection }}</span>
        </template>
      </div>
       <div v-if="canChangeSanctions">
        <template>
          <SanctionIcon :sanction="currentSanction"></SanctionIcon>
          <span class="requerimiento-status">{{ currentSanction }}</span>
          <span @click.stop="">
            <SanctionEstado
              ref="sanction"
              :correction="currentSanction"
              :field="field"
              :sanctions="sanctions"
              @changeCurrentSanction="changeCurrentSanction"
              :canEdit="canChangeSanctions"
            ></SanctionEstado>
          </span>
        </template>
      </div>
       <div v-if="canViewSanction">
        <template>
           <SanctionIcon :sanction="currentSanction"></SanctionIcon>
          <span class="requerimiento-status">{{ currentSanction }}</span>
        </template>
      </div>
      <!--select warning group-->
    </v-card-text>
    <!--comienzo observacion-->
     <div
      class="mx-4"
      style="display: flex; align-items: center; justify-content:right;"
    >
   <v-flex xs10>
    <v-textarea
        outline
        full-width
        height=60
        v-model="observation"
        placeholder="Observación"
        @input="onInputChangeObservation"
        :readonly="!canEdit"
      >
      </v-textarea>
       </v-flex>
      </div>
      <!--Fin Observacion-->
    <!--comienzo adjunto-->
    <div
      v-if="field.requireAttachment && !canViewCarousel"
      class="mx-4"
      style="display: flex; align-items: center; justify-content:center;"
    >
      <v-card-title>
        <span
          style="color:black;font-size:15px;font-family:SourceSansProRegular, sans-serif;font-weight: bold;"
          >Archivo:</span
        >
      </v-card-title>
      <v-data-table
        :items="initials"
        hide-actions
        hide-headers
        v-if="initialFiles.length"
        no-data-text="No hay datos disponibles"
      >
        <template slot="items" slot-scope="props">
          <tr class="row-element" :key="props.item.asset.id">
            <td>
              <v-flex py-2>
                <v-img
                  v-if="isImage(props.item)"
                  :src="props.item.asset.url"
                  max-height="100"
                  width="150"
                ></v-img>
                <v-icon v-else color="primary lighten-2">description</v-icon>
              </v-flex>
            </td>
            <td>
              <a :href="props.item.asset.url" target="_blank">{{
                props.item.asset.name
              }}</a>
            </td>
            <td>{{ props.item.uploadDate }}</td>
            <td class="text-xs-left">{{ props.item.asset.description }}</td>
            <td class="text-xs-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    v-if="canEdit"
                    icon
                    @click="remove(props.item)"
                    :disabled="false"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <div
      v-if="field.requireAttachment"
      class="mx-4"
      style="display: flex; align-items: center; justify-content:center;"
    >
      <AttachFileInforme
        ref="fileInput"
        :description="true"
        @upload="uploadFiles"
      ></AttachFileInforme>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            v-if="canEdit"
            icon
            :disabled="agregarFoto || files.length > 0"
            @click="openFileDirectory"
          >
            <v-icon>attach_file</v-icon>
          </v-btn>
        </template>
        <span>Adjuntar Archivos</span>
      </v-tooltip>

    </div>
     <!--CARROUSEL-->
     <div
      v-if="field.requireAttachment && canViewCarousel && hasAdjuntos"
      style="display: flex; align-items: center; justify-content:center; flex-direction: column; width:650px; margin-left:auto; margin-right:auto;">
      <CarouselInforme v-if="imageAdjuntos.length !== 0" :attachments="imageAdjuntos"></CarouselInforme>
      <div v-if="filesAdjuntos.length !== 0">
          <v-card-text class="" style="gap:10px;">
            <v-card-title style="display: flex; flex-direction: column;">
              <span style="color:black;font-size:15px;font-family:SourceSansProRegular, sans-serif;font-weight: bold;">Archivos:</span>
              <div v-for="item in filesAdjuntos" :key="item.asset.id">
                <v-icon color="primary lighten-2">description</v-icon>
                <a style="font-size: 15px;" class="light-blue--text" :href="item.asset.url" target="_blank">{{ item.asset.name }}</a>
                <span v-if="item.asset.description" style="font-size: 15px;"> <i> - Descripción: {{ item.asset.description }} </i></span>
            </div>
            </v-card-title>
          </v-card-text>
      </div>
    </div>
    <!--CARROUSEL-->
    <div
      v-if="canViewComments"
      class="mx-4"
      style="display: flex; align-items: center; justify-content:center; "
    >
      <InformeAuditoriaFieldComments
        :field="field"
        :canAddComments="canAddComments"
      ></InformeAuditoriaFieldComments>
    </div>
    <!--fin adjunto-->
  </div>
</template>

<script>
import AttachFileInforme from '../../../../common/ui/AttachFileInforme'
import { s3UploadMixin } from '../../../../mixins/s3UploadMixin'
import IncumplimientoIcon from './IncumplimientoIcon.vue'
import IncumplimientoEstado from './IncumplimientoEstado.vue'
import Constants from '../../../../common/constants'
import InformeAuditoriaFieldComments from './InformeAuditoriaFieldComments'
import CorrectionIcon from './CorrectionIcon.vue'
import CorrectionEstado from './CorrectionEstado.vue'
import CarouselInforme from './CarouselInforme.vue'
import Compressor from 'compressorjs'
import SanctionIcon from './SanctionIcon.vue'
import SanctionEstado from './SanctionEstado.vue'

export default {
  mixins: [s3UploadMixin],
  props: {
    fetchPath: {
      type: String,
      default: 'informe-auditoria/torneos'
    },
    field: Object,
    canEdit: Boolean,
    label: String,
    fetchScalePath: {
      type: String,
      default: 'informe-auditoria/scale'
    },
    adjuntoPath: {
      type: String,
      default: 'informe-auditoria/adjunto'
    },
    canChangeCheckbox: Boolean,
    canViewComments: Boolean,
    canViewCorrection: Boolean,
    canAddComments: Boolean,
    canViewCarousel: Boolean,
    canChangeSanctions: Boolean,
    canViewSanction: Boolean,
    index: null
  },
  data () {
    return {
      data: '',
      listItems: [],
      observation: '',
      listScaleValues: [],
      scale: null,
      scaleValue: null,
      removedFiles: [],
      initialFiles: [],
      loading: false,
      files: [],
      currentIncumplimiento: '',
      incumplimientos: ['Ok', 'Advertencia'],
      currentCorrection: '',
      corrections: ['Valido', 'Revisar'],
      currentSanction: '',
      sanctions: ['Revisado OK', 'Advertencia', 'Incumplimiento'],
      imageAdjuntos: [],
      filesAdjuntos: []
    }
  },
  methods: {
    rules () {
      if (!this.field.mandatory) {
        return false
      } else {
        return !!this.data || 'Este campo es requerido'
      }
    },
    onInputChange (event) {
      this.field.responseValue = event
      this.$emit('updateField', this.field)
    },
    onInputChangeObservation (event) {
      this.field.observation = event
      this.$emit('updateField', this.field)
    },
    fetchItems () {
      this.loading = true
      this.axios
        .get(`${this.fetchPath}`)
        .then(response => {
          this.listItems = response.data
          this.data = Number(this.field.responseValue)
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    onInputChangeScaleValue (event) {
      this.field.scaleValue = Number(event)
      this.$emit('updateField', this.field)
    },
    fetchScaleValues () {
      this.loading = true
      this.axios
        .get(`${this.fetchScalePath}/${this.scale}`)
        .then(response => {
          this.listScaleValues = response.data
          this.scaleValue = Number(this.field.scaleValue)
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    submit () {
      this.loading = true
      let payload = {
        field: this.field,
        assets: this.assets
      }
      this.axios
        .post(`${this.adjuntoPath}`, payload)
        .then(response => {
          this.files = []
          this.$emit('updateField', response.data.field)
          this.initialFiles = response.data.field.fieldAdjuntos
          this.$refs.fileInput.cleanContent()
          this.postSubmit()
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.loading = false
        })
    },
    remove (item) {
      this.loading = true
      let payload = {
        field: this.field,
        removed: [item.asset]
      }
      this.axios
        .post(`${this.adjuntoPath}`, payload)
        .then(response => {
          this.$emit('updateField', response.data.field)
          this.initialFiles = response.data.field.fieldAdjuntos
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.loading = false
        })
    },
    cleanAddedFiles () {
      this.$refs.fileInput.cleanContent()
    },
    borrarGuardar () {
      document.getElementById('btnsave').setAttribute('disabled', 'disabled')
      if (this.removedFiles.length > 0) {
        this.loading = true
        let payload = {
          field: this.field,
          removed: this.removedFiles
        }
        this.axios
          .post(`${this.adjuntoPath}`, payload)
          .then(response => {
            this.removedFiles = []
            this.files = []
            this.$emit('updateField', response.data.field)
            this.initialFiles = response.data.field.fieldAdjuntos
            this.$refs.fileInput.cleanContent()
            this.postSubmit()
            this.loading = false
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.loading = false
          })
      } else {
        this.compressAndSendImg()
      }
    },
    preSubmit () {},
    isValidForm () {
      return this.files.length > 0
    },
    uploadFiles (newFiles) {
      this.files = newFiles
      if (this.files.length > 0) {
        this.compressAndSendImg()
      }
    },
    onChangeCorrectionValue (event) {
      this.field.correction = event
      this.$emit('updateField', this.field)
    },
    isImage (file) {
      return file.asset.fileType.match('image.*')
    },
    changeCurrentIncumplimiento (incumplimiento) {
      this.currentIncumplimiento = incumplimiento
      this.field.incumplimiento.description = incumplimiento.toString()
      this.field.incumplimiento.id = this.getIdIncumplimiento(incumplimiento)
      if (incumplimiento === 'Advertencia') {
        this.field.sanction.description = 'Advertencia'
        this.field.sanction.id = 2
      } else {
        this.field.sanction.description = 'Revisado OK'
        this.field.sanction.id = 1
      }
      this.$emit('updateField', this.field)
    },
    getIdIncumplimiento (incumplimiento) {
      let id
      if (incumplimiento === Constants.IS_FIELD_WRONG) {
        id = 2
      } else if (incumplimiento === Constants.IS_FIELD_WARNING) {
        id = 3
      } else {
        id = 1
      }
      return id
    },
    changeCurrentCorrection (correction) {
      this.currentCorrection = correction
      this.field.correction.description = correction.toString()
      this.field.correction.id = this.getIdCorrection(correction)
      this.$emit('updateField', this.field)
    },
    getIdCorrection (correction) {
      let id
      if (correction === Constants.IS_FIELD_REVISAR) {
        id = 2
      } else {
        id = 1
      }
      return id
    },
    compressAndSendImg () {
      let arrayPromise = []
      let keyFiles = []
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].type.match(('image/*'))) {
          arrayPromise.push(this.compressImgPromise(this.files[i]))
          keyFiles.push({ name: this.files[i].name, id: i })
        }
      }

      Promise.allSettled(arrayPromise)
        .then((results) => results.forEach((result, index) => {
          keyFiles.forEach(key => {
            if (key.name === result.value.name) {
              this.files.splice(key.id, 1, result.value)
            }
          })
        })).then(result => {
          this.uploadAllFiles()
        })
    },
    compressImgPromise (file) {
      return new Promise((resolve, reject) => {
        /* eslint-disable no-new */
        new Compressor(file, {
          quality: Constants.IMG_COMPRESSOR_QUALITY,
          success (result) {
            let mime = result.type
            resolve(new File([result], result.name, { type: mime }))
          },
          error (err) {
            reject(err.message)
          }
        })
      })
    },
    changeCurrentSanction (sanction) {
      this.currentSanction = sanction
      this.field.sanction.description = sanction.toString()
      this.field.sanction.id = this.getIdSanction(sanction)
      this.$emit('updateField', this.field)
    },
    getIdSanction (sanction) {
      let id
      if (sanction === Constants.IS_FIELD_REVISADO_OK) {
        id = 1
      } else if (sanction === Constants.IS_FIELD_ADVERTENCIA) {
        id = 2
      } else {
        id = 3
      }
      return id
    },
    getImageAdjuntos () {
      this.imageAdjuntos = []
      for (let i = 0; i < this.field.fieldAdjuntos.length; i++) {
        if (this.field.fieldAdjuntos[i].asset.fileType.match('image/*') ||
            this.field.fieldAdjuntos[i].asset.fileType.match('video/*')) {
          this.imageAdjuntos.push(this.field.fieldAdjuntos[i])
        }
      }
      return this.imageAdjuntos
    },
    getFilesAdjuntos () {
      for (let i = 0; i < this.field.fieldAdjuntos.length; i++) {
        if (this.field.fieldAdjuntos[i].asset.fileType.match('.pdf') ||
            this.field.fieldAdjuntos[i].asset.fileType.match('application/vnd.openxmlformats-officedocument.wordprocessingml.document') ||
            this.field.fieldAdjuntos[i].asset.fileType.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
          this.filesAdjuntos.push(this.field.fieldAdjuntos[i])
        }
      }
      return this.filesAdjuntos
    }
  },
  computed: {
    guardarCambios () {
      if (this.files.length > 0 || this.removedFiles.length > 0) {
        return false
      } else {
        return true
      }
    },
    initials () {
      return this.initialFiles
    },
    agregarFoto () {
      return false
    },
    hasAdjuntos () {
      return (this.field.fieldAdjuntos.length > 0)
    }
  },
  components: {
    AttachFileInforme,
    IncumplimientoIcon,
    IncumplimientoEstado,
    InformeAuditoriaFieldComments,
    CorrectionEstado,
    CorrectionIcon,
    CarouselInforme,
    SanctionIcon,
    SanctionEstado
  },

  watch: {
    'field.fieldAdjuntos' () {
      this.initialFiles = this.field.fieldAdjuntos
    }
  },
  created () {
    this.data = this.field.responseValue
    this.listItems = this.fetchItems()
    this.observation = this.field.observation
    if (this.field.requireScale) {
      this.scale = this.field.scale.id
      this.listScaleValues = this.fetchScaleValues()
    }
    this.initialFiles = this.field.fieldAdjuntos
    this.currentIncumplimiento = this.field.incumplimiento.description
    this.currentCorrection = this.field.correction.description
    this.currentSanction = this.field.sanction.description
    if (this.field.fieldAdjuntos) {
      this.getImageAdjuntos()
      this.getFilesAdjuntos()
    }
  }
}
</script>
<style>
i.fa-check-circle {
  color: green !important;
}
i.fa-times {
  color: red !important;
}
i.green-icon {
  color: green !important;
}
i.yellow-icon {
  color: #b5a707 !important;
}
i.red-icon {
  color: red !important;
}
.requerimiento-status {
  margin-left: 0.2em;
}
</style>
